export const getQuoteEmailData = ({ quoteEmailData }) => quoteEmailData
